import styled from "styled-components";

const Files = styled.div`
  margin-top: -8px;
  & > * {
    margin: 8px 0;
  }
`;

const StyledFileList = styled.div``;

export default StyledFileList;
export { Files };
